// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2wZ1r","empty":"ModalGraph_empty__1UhTO"};